import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  firstName: "",
  lastName: "",
  username: "",
  email: "",
  password: "",
  radiologistType: 0,
  roles: [
    {
      id: 0,
      name: "",
    },
  ],
  provider: "",
  firm: {
    id: 0,
    name: "",
    code: null,
    address: null,
    contact1: null,
    contact2: null,
    contact3: null,
    active: false,
    triageCTStudies: false,
    triageXRAYStudies: false,
    masterStudyReportId: null,
    reportHeaderDto: null,
    isDOC: null,
    isDOCX: null,
    isPDF: null,
    isPDFWithImage: null,
    isPDFWithKeyImage: null,
    isDOCXWithKeyImage: null,
    addTimeToReport: false,
    addDateToReport: false,
    addSupervisorSignature: false,
    signature2Dto: null,
    signature3Dto: null,
    firmType: null,
    firmCode: null,
    firmRole: null,
    createdTimeString: null,
    updatedTimeString: null,
    password_protected: false,
    schemeCode: null,
    firmIdList: [],
    qcEnabled: null,
    twoSignaturesAllowed: null,
    modalityIds: null,
  },
  dummyPassword: null,
  redirectOnLogin: false,
  accountNonLocked: true,
  forceReset: false,
};

export const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState: { value: initialState },
  reducers: {
    saveUserDetails: (state, action) => {
        // console.log(action.payload)
      state.value = action.payload;
    },
    deleteUserDetails: (state) => {
      state.value = initialState;
    },
  },
});

export const { saveUserDetails, deleteUserDetails } = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
